import { useState } from "react";
import { v4 as UUID } from "uuid";

const AddAlert = () => {
  const [alerts, setAlerts] = useState([]);

  const removeAlert = (id) =>
    setAlerts((prev) => prev.filter((a) => a.id !== id));

  // `key` is optional. When provided, any existing alert with the same key
  // is replaced — useful for keeping a single "validation" or "submit" alert
  // alive instead of stacking duplicates on every click.
  // `autoDismissMs` removes the alert after the given delay.
  const setAlert = (message, color, key, autoDismissMs) => {
    const id = UUID();
    setAlerts((prev) => {
      const filtered = key ? prev.filter((a) => a.key !== key) : prev;
      return [...filtered, { id, key, message, color }];
    });
    if (autoDismissMs && autoDismissMs > 0) {
      setTimeout(() => removeAlert(id), autoDismissMs);
    }
  };

  const clearAlerts = () => setAlerts([]);

  return { alerts, setAlerts, setAlert, clearAlerts };
};

export default AddAlert;
